package xim.poc.game.configuration.v0.tactics.behaviors

import xim.poc.game.ActorState
import xim.poc.game.configuration.BehaviorId
import xim.poc.game.configuration.constants.*
import xim.poc.game.event.ActorAttackedEvent

object TacticsItemMobBehaviorId: BehaviorId

class TacticsItemMobBehavior(actorState: ActorState): TacticsBehaviorController(actorState) {

    companion object {
        private val forbiddenSkills = (spellFlare_204.id .. spellFloodII_215.id).map { SpellSkillId(it) }.toSet() + spellFullCure_893
    }

    override fun getSelectableSkills(): List<SkillId> {
        return super.getSelectableSkills() - forbiddenSkills
    }

    override fun estimateSkillValue(query: TacticsSkillQuery): Float {
        if (query.skill is SpellSkillId && query.result.events.any { it is ActorAttackedEvent }) {
            return 1f
        }

        return super.estimateSkillValue(query)
    }

}